import { Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import type { PromotionInput } from '@weft/types';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { getDefaultCreditPromotion,
  getDefaultPercentagePromotion } from '../../../../../create-plan-page-consts/add-item-button-consts';
import type { NewPlanForm } from '../../../../CreatePlanForm/create-plan-form-types/new-plan-form';
import type { PlanInputForm } from '../../../../CreatePlanForm/create-plan-form-types/plan-input-form';

export const PromotionsChargesMenuItems: React.FC = () => {
  const { setValue, getValues } = useFormContext<PlanInputForm, NewPlanForm>();

  const handlePromotionClick = (defaultPromotionCallback: () => PromotionInput) => {
    return () => {
      const currentPromotions = getValues('promotions') ?? [];
      const defaultPromotion = defaultPromotionCallback();
      const updatedPromotions = [...currentPromotions, defaultPromotion];
      setValue('promotions', updatedPromotions);
    };
  };

  return (
    <>
      <MenuItem
        className="flex flex-col items-start"
        onClick={handlePromotionClick(getDefaultCreditPromotion)}
      >
        <Typography className="text-sm font-normal text-black">Credits Discount</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Fixed amount off purchase</Typography>
      </MenuItem>

      <MenuItem
        className="flex flex-col items-start"
        onClick={handlePromotionClick(getDefaultPercentagePromotion)}
      >
        <Typography className="text-sm font-normal text-black">Percentage Discount</Typography>
        <Typography className="text-xs font-normal text-[#94A0A4]">Variable amount off total purchase</Typography>
      </MenuItem>
    </>
  );
};